import { ReadonlyRecord } from '@bimser/core';
import { List, Record } from 'immutable';
import { DataSourceParameterValueType, ValueModifierType } from '../Types';

export interface IBaseDataSourceParameter {
	name: string;
	isRequired: boolean;
	length?: number; // Value olarak seçilebilecek alanların uzunluklarının length ten küçük veya eşit olması kontrolü sağlanmalı
	valueType: DataSourceParameterValueType;
	valueModifier: ValueModifierType;
	value?: any; // Value dolu gelirse, default value olarak kullanılır.
	field?: string;
}

export interface IDataSourceParameter extends IBaseDataSourceParameter {
	children?: Array<IDataSourceParameter>;
}

export interface IReadonlyBaseIDataSourceParameter extends IBaseDataSourceParameter {
	children?: List<DataSourceParameter>;
}

export type DataSourceParameter = ReadonlyRecord<IReadonlyBaseIDataSourceParameter>;

export const DataSourceParameterFactory = Record<IReadonlyBaseIDataSourceParameter>({
	name: null,
	isRequired: false,
	length: null,
	valueType: null,
	valueModifier: null,
	value: null,
	field: null,
	children: List()
});

export const DataSourceParameterFactoryFromJS = function (
	args: IDataSourceParameter
): DataSourceParameter {
	return DataSourceParameterFactory({
		...args,
		children: List(
			args.children ? args.children.map(i => DataSourceParameterFactoryFromJS(i)) : []
		)
	});
};
